<template>
  <footer class="footer">
    <Container>
      <div class="footer__content">
        <div class="footer__top">
          <div class="footer__logo">
            <FooterLogo class="logo--without-text logo--small" />
          </div>
          <FooterWarnings :images="getPegiImages" />
        </div>
        <FooterBottom :copyright="getCopyright" :links="linkItems" />
      </div>
    </Container>
  </footer>
</template>

<script>
import Container from "@app_components/components/container/vue/Container.vue";
import FooterWarnings from "@static_promo_pages/common/components/redesign/the-footer/vue/blocks/FooterWarnings.vue";
import FooterBottom from "@static_promo_pages/common/components/redesign/the-footer/vue/blocks/FooterBottom.vue";
import FooterLogo from "@static_promo_pages/common/components/redesign/the-footer/vue/blocks/FooterLogo.vue";

export default {
  name: "TheFooter",
  components: {
    Container,
    FooterWarnings,
    FooterBottom,
    FooterLogo,
  },
  props: {
    linkItems: {
      type: Array,
      default: () => [],
    },
    pegi: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getPegiImages() {
      return this.pegi.filter(item => item !== null).map(image => `footer/${image}.png`)
    },
    getCopyright() {
      return this.$t("footer.copyright", {
        year: new Date().getFullYear(),
      })
    },
  },
};
</script>

<style lang="scss">
@import "../styles/footer.scss";
</style>
